import { PiChatCircle } from 'react-icons/pi';
import { EmptyState } from 'src/modules/shared/components/atoms/states/empty-state';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import { useScrollHint } from 'src/modules/shared/hooks/scroll/hint';

/**
 * Keeps an empty conversation readable within the timeline's available height.
 * @returns A scrollable history region containing the original empty content.
 */
export const TimelineEmptyState = () => {
  const { containerRef, isScrollable } = useScrollHint({ initDelayMs: 0 });
  const { t } = useI18n();
  const icon = (
    <PiChatCircle aria-hidden className="h-full w-full text-primary-500" />
  );
  return (
    <div
      ref={containerRef}
      role="region"
      aria-label={t('communications.timeline.historyLabel')}
      tabIndex={isScrollable ? 0 : -1}
      className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden overscroll-contain focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-primary-500"
    >
      <EmptyState
        title={t('communications.timeline.emptyTitle')}
        description={t('communications.timeline.emptyDescription')}
        icon={icon}
        className="!h-auto min-h-full"
      />
    </div>
  );
};
